import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentStep: 0,
    // 进程id
    processId: '',
    // 所有表格数据
    tableData: [],
    // 勾选的表格数据(包含占位数据)
    checkTableData: [],
    // 第二步的所有表格数据
    bindTableData: [],
    // 缓存key
    cacheKey: '',
    // 保存的设备信息list
    deviceQueryList: [],
  },
  mutations: {
    setCurrentStep(state, currentStep) {
      state.currentStep = currentStep;
    },
    setProcessId(state, processId) {
      state.processId = processId;
    },
    setTableData(state, tableData) {
      // debugger;
      state.tableData = tableData;
    },
    setCheckTableData(state, checkTableData) {
      // debugger
      state.checkTableData = checkTableData;
    },
    setBindTableData(state, bindTableData) {
      // debugger
      state.bindTableData = bindTableData;
    },
    setCacheKey(state, cacheKey) {
      state.cacheKey = cacheKey;
    },
    spliceIndexTableData(state, index) {
      if(index === -1){
        return;
      }
      state.tableData.splice(index, 1);
    },
    spliceTableData(state, currentCheck) {
      this.commit('spliceTarget', {
        array: state.tableData,
        obj: currentCheck,
      });
    },
    spliceCheckTableData(state, currentCheck) {
      this.commit('spliceTarget', {
        array: state.checkTableData,
        obj: currentCheck,
      });
    },
    spliceBindTableData(state, currentCheck) {
      this.commit('spliceTarget', {
        array: state.bindTableData,
        obj: currentCheck,
      });
    },
    spliceTarget(state, { array, obj }) {
      const index = array.indexOf(obj);
      if (index === -1) {
        return [];
      }
      return array.splice(index, 1);
    },
    clearProcessInfo(state) {
      state.currentStep = 0;
      state.processId = '';
      state.tableData = [];
      state.checkTableData = [];
      state.bindTableData = [];
      state.cacheKey = '';
    },
    // 存入已保存的设备信息
    updateDeviceQueryList(state, payload) {
      let index = state.deviceQueryList.findIndex(e => e.deviceUnit === payload.deviceUnit);
      if (index !== -1) {
        state.deviceQueryList[index] = Object.assign({}, payload);
      } else {
        state.deviceQueryList.push(Object.assign({}, payload));
      }
    },
  },
  actions: {
    // 存入保存的设备信息
    updateDeviceQueryFn({ commit }, payload) {
      commit('updateDeviceQueryList', payload);
    },
  },
  getters: {
    getQueryList (state) {
      return state.deviceQueryList;
    }
  },
  modules: {},
});
